import { createStyles, makeStyles } from '@mui/styles'

const useStyles = makeStyles(() =>
  createStyles({
    box: {
      display: 'flex',
      width: '100%',
      height: 154,
      '& .recharts-cartesian-axis-tick-labels': {
        '& .recharts-layer:first-child': {
          '& text': {
            transform: 'translate(-7px, 15px)',
          },
        },
        '& .recharts-layer:last-child': {
          '& text': {
            transform: 'translate(7px, 15px)',
          },
        },
      },
      '& .recharts-cartesian-axis-tick-label': {
        fontSize: 14,
        fontWeight: 700,
        lineHeight: '140%',
        position: 'relative',
        '& text': {
          fill: '#000',
          transform: 'translate(0, 15px)',
        },
        '&:after': {
          display: 'block',
          position: 'absolute',
          zIndex: 1,
          top: '-10px',
          left: '50%',
          transform: 'translateX(-50%)',
          content: '',
          width: 5,
          height: 5,
          borderRadius: '50%',
          background: '#EBEBEB',
        },
      },
      '&, *': {
        outline: 'none',
      },
    },
  })
)

export default useStyles
